// libs
import React, { useMemo } from 'react';

import { useTranslation } from '@lyearn/i18n';
import { cn } from '@lyearn/style';
// components
import * as LearningContent from '@/modules/corporate/components/LearningContent';
// types
import { ContentEntity } from '@/types/schema';

import { adaptContent } from '../../helpers';
import ContentDetail from '../ContentDetail';

function ContentItem(props: {
  content: ContentEntity;
  className?: string;
  isOptional?: boolean;
  isMandatory?: boolean;
  isOptionalContentInPath?: boolean;
}) {
  const { t } = useTranslation();
  const { content, className, isOptional, isMandatory, isOptionalContentInPath } = props;
  const adaptedContent = useMemo(() => adaptContent(t, content), [t, content]);

  return (
    <LearningContent.Provider
      className={cn('flex w-full items-center justify-between truncate', className)}
      content={adaptedContent}>
      <ContentDetail
        content={adaptedContent}
        isMandatory={isMandatory}
        isOptional={isOptional}
        isOptionalContentInPath={isOptionalContentInPath}
      />
    </LearningContent.Provider>
  );
}

export default ContentItem;
